import cn from 'classnames';
import { FC } from 'react';
import { IoMdArrowDropright } from 'react-icons/io';
import { Checkbox } from '../../../components/checkbox/checkbox';
import { IconButton } from '../../../components/icon-button/icon-button';
import { useToggle } from '../../../hooks/use-toggle';
import { NestedIdValue } from '../use-multi-select';
import s from './nested-multi-select-options-item.module.css';

interface Props {
  item: NestedIdValue;
  onSelect: (item: NestedIdValue) => void;
  value: NestedIdValue[];
  nest?: number;
}

const padLeft = 20;
export const NestedMultiSelectOptionsItem: FC<Props> = (props) => {
  const { item, onSelect, value, nest = 0 } = props;
  const [isOpen, toggleOpen] = useToggle();

  const isChecked = value?.some((el) => el.id === item.id);
  const partial = item.children?.map((el) => value.some((v) => v.id === el.id));

  return (
    <li className={s.feature} style={{ paddingLeft: padLeft * nest }}>
      <Checkbox
        onClick={() => onSelect(item)}
        label={item.value}
        partialArray={item.children?.length ? partial : undefined}
        wrapperClassname={s.option}
        checked={!item.children?.length && isChecked}
      />

      {!!item.children?.length && (
        <>
          <IconButton
            className={cn(s.arrow, isOpen && s.open)}
            variant="ghost"
            size="sm"
            onClick={toggleOpen}
          >
            <IoMdArrowDropright />
          </IconButton>
          {isOpen && (
            <ul className={s.options}>
              {item.children.map((child) => (
                <NestedMultiSelectOptionsItem
                  item={child}
                  onSelect={onSelect}
                  value={value}
                  key={child.id}
                  nest={nest + 1}
                />
              ))}
            </ul>
          )}
        </>
      )}
    </li>
  );
};
